var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInterfaceQueueStats = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7071 4.47485L22.3431 1.11089C21.9526 0.720362 21.3195 0.720362 20.9289 1.11089C20.5384 1.50141 20.5384 2.13458 20.9289 2.5251L22.5858 4.18195L1 4.18196C0.447716 4.18196 0 4.62967 0 5.18196C0 5.73424 0.447716 6.18196 1 6.18196L22.5858 6.18195L20.9289 7.83881C20.5384 8.22933 20.5384 8.8625 20.9289 9.25302C21.3195 9.64355 21.9526 9.64355 22.3431 9.25302L25.7071 5.88906C26.0976 5.49854 26.0976 4.86537 25.7071 4.47485ZM0 11.432H3V14.432H0V11.432ZM3 16.807H0V19.807H3V16.807ZM3 22.182H0V25.182H3V22.182ZM8.75 22.182H5.75V25.182H8.75V22.182ZM5.75 16.807H8.75V19.807H5.75V16.807ZM8.75 11.432H5.75V14.432H8.75V11.432ZM11.5 22.182H14.5V25.182H11.5V22.182ZM14.5 16.807H11.5V19.807H14.5V16.807ZM11.5 11.432H14.5V14.432H11.5V11.432ZM20.25 22.182H17.25V25.182H20.25V22.182ZM17.25 16.807H20.25V19.807H17.25V16.807ZM20.25 11.432H17.25V14.432H20.25V11.432ZM23 22.182H26V25.182H23V22.182ZM26 16.807H23V19.807H26V16.807ZM23 11.432H26V14.432H23V11.432Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInterfaceQueueStats);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/interface-queue-stats.3583d11249d187a68c98433d3bf3ded5.svg";